import CancelablePromise from 'mn-utils/CancelablePromise';
import {TResponse} from '@/types';
import {get} from '../../http';
import {getStaticAdminStatistic} from './mock';

export function apiAdminStatistic(params): Promise<TResponse> {
  const url = '/f2c/v1/admin/dashboard/overview';

  if (process.env.MOCK) {
    const response = getStaticAdminStatistic();
    console.info({url, response});
    return CancelablePromise.delay(500, response);
  }

  return get(url, params);
}
